<template>
<footer id="footer" class="footer">
    <div class="container">
        <div class="has-text-centered copyright">© {{year}} {{site_data.siteconfig.title}}.</div>
    </div>
</footer>
</template>

<script>
export default {
    name: 'Footer',
    props: [
        'site_data'
    ],
    data: function() {
        return {

        };
    },
    components: {},
    watch: {

    },
    computed: {
        year() {
            let d = new Date();

            return d.getFullYear();
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/Footer.vue